import {
  AnyAction,
  createAsyncThunk,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { GetInstituteByIdRequest } from '../pages/app/Manage/InstituteProfile/service/institute.request';
import { ActiveInstituteIntialStateDTO, instituteDetailsDTO } from './types';
import { updateInstituteDetails } from '../pages/app/Manage/InstituteProfile/service/instituteSlice';
import { DeleteEntity } from './request';
import { setToastNotification } from '../components/ToastNotification/service/toastNotificationSlice';

export const initialState: ActiveInstituteIntialStateDTO = {
  error: false,
  loading: false,
  success: false,
  data: null,
  deleteEntitySuccess: false,
  deleteEntityLoading: false,
  deleteEntityError: false,
  deletedLeadId: null,
};

const storeDataInLocalStorage = async (data: any) => {
  try {
    localStorage.setItem('ACTIVE_INSTITUTE', JSON.stringify(data));
  } catch (e) {}
};

export const SetActiveInstitute = createAsyncThunk(
  'user/activeInstitute',
  (data: string, { dispatch }) => {
    return GetInstituteByIdRequest(data)
      .then((response: any) => {
        if (response.status === 200) {
          storeDataInLocalStorage(response?.data?.data);
          dispatch(updateInstituteDetails(response?.data?.data));
        }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        throw e.response.data;
      });
  }
);

export const deleteEntity = createAsyncThunk(
  'user/deleteEntity',
  (data: any, thunkAPI) => {
    return DeleteEntity(data)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: 'success',
              snackOpen: true,
            })
          );
        }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: 'error',
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const activeInstituteSlice = createSlice({
  name: 'activeInstitute',
  initialState,
  reducers: {
    reset: () => initialState,
    setActiveInsitute: (state, action: PayloadAction<instituteDetailsDTO>) => {
      state.data = action.payload;
    },
    resetDeleteEntitySuccess: (state) => {
      state.deleteEntitySuccess = false;
      state.deleteEntityError = false;
    },

    resetDeletedLeadId: (state) => {
      state.deletedLeadId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(SetActiveInstitute.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.success = false;
    });
    builder.addCase(
      SetActiveInstitute.fulfilled,
      (state, action: PayloadAction<instituteDetailsDTO>) => {
        state.loading = false;
        state.error = false;
        state.success = true;
        state.data = action?.payload;
      }
    );
    builder.addCase(SetActiveInstitute.rejected, (state, action: AnyAction) => {
      state.success = false;
      state.loading = false;
      state.error = action?.error?.message || 'Something went wrong';
    });
    builder.addCase(deleteEntity.pending, (state) => {
      state.deleteEntityLoading = true;
      state.deleteEntitySuccess = false;
      state.deleteEntityError = false;
    });
    builder.addCase(
      deleteEntity.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.deleteEntityLoading = false;
        state.deleteEntitySuccess = true;
        state.deleteEntityError = false;
        state.deletedLeadId =
          action.payload?.entityType === 'ENQUIRY' ? action.payload?.id : null;
      }
    );
    builder.addCase(deleteEntity.rejected, (state, action: AnyAction) => {
      state.deleteEntityLoading = false;
      state.deleteEntitySuccess = false;
      state.deleteEntityError =
        action?.error?.message || 'Something went wrong';
    });
  },
});

export default activeInstituteSlice.reducer;
export const {
  reset,
  setActiveInsitute,
  resetDeleteEntitySuccess,
  resetDeletedLeadId,
} = activeInstituteSlice.actions;
